const QUERY_PARAM = 'from';
const QUERY_VALUE = 'mobile-app';

/**
 * True when the page was opened from the mobile app's in-app browser
 * (mobile appends `?from=mobile-app` to the static URLs in Settings).
 *
 * Driven directly off the URL each render — no sessionStorage — so the
 * behavior is fully predictable when testing: param present → embedded,
 * param absent → normal. The in-app browser shows only leaf pages with
 * no internal navigation, so persistence isn't needed.
 */
export function isEmbeddedInMobileApp(): boolean {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get(QUERY_PARAM) === QUERY_VALUE;
}
